/*
For now, this file needs to be es5 because it's imported inside next.config.js, which is not run through Babel.
If that changes, then this file can be upgraded to es6.
 */
const cs_production = require('./production/config.json');
const cs_development = require('./development/config.json');
const cs_beta = require('./beta/config.json');
const sb_production = require('./production/schoolblocks_config.json');
const sb_development = require('./development/schoolblocks_config.json');
const sb_beta = require('./beta/schoolblocks_config.json');

// This is leftover as a reminder of what it "should" be, when we can use es6 again.
//import {isSchoolBlocksApp} from "./utils/SchoolBlocksUtilities";
function isSchoolBlocksApp() {
    return typeof window === 'object' ? "SchoolBlocksApp" in window : process.env.NEXT_PUBLIC_IS_SCHOOLBLOCKS === "true";
}

const allConfigs = {
    'dev': {
        'cs': cs_development,
        'sb': sb_development,
    },
    'beta': {
        'cs': cs_beta,
        'sb': sb_beta,
    },
    'prod': {
        'cs': cs_production,
        'sb': sb_production,
    },
};

let appEnv = 'dev';

// This object should be consistent with the NextJS configuration object and is defined as a type in TypeScript.
const appConfig = {
    serverRuntimeConfig: {},
};

if (isSchoolBlocksApp() && process.env.NEXT_PUBLIC_IS_SCHOOLBLOCKS) {
    appEnv = process.env.NEXT_PUBLIC_APP_ENV || appEnv;
    appConfig.publicRuntimeConfig = allConfigs[appEnv].sb;
} else if (isSchoolBlocksApp()) {
    appEnv = SchoolBlocksApp.appEnv || appEnv;
    appConfig.publicRuntimeConfig = allConfigs[appEnv].sb;
} else {
    appEnv = process.env.NEXT_PUBLIC_APP_ENV || appEnv; //eslint-disable-line
    appConfig.publicRuntimeConfig = allConfigs[appEnv].cs;
}

module.exports = appConfig;
